import Alpine from 'alpinejs';

import collapsePlugin from '@alpinejs/collapse';
import focusPlugin from '@alpinejs/focus';
import intersectPlugin from '@alpinejs/intersect';

import action from './mixins/action';
import accordion from './mixins/accordion';
import dropdown from './mixins/dropdown';
import fileUploader from './mixins/file-uploader';
import multi from './mixins/multi';
import multiKeyValue from './mixins/multi-key-value';
import saver from './mixins/saver';
import selector from './mixins/selector';
import tabs from './mixins/tabs';
import toggle from './mixins/toggle';

window.Alpine = Alpine;

Alpine.plugin(collapsePlugin);
Alpine.plugin(focusPlugin);
Alpine.plugin(intersectPlugin);

Alpine.data('action', action);
Alpine.data('accordion', accordion);
Alpine.data('dropdown', dropdown);
Alpine.data('fileUploader', fileUploader);
Alpine.data('multi', multi);
Alpine.data('multiKeyValue', multiKeyValue);
Alpine.data('saver', saver);
Alpine.data('selector', selector);
Alpine.data('tabs', tabs);
Alpine.data('toggle', toggle);

Alpine.start();
